<template>
  <dropdown v-tooltip="disabled ? this.$t('message.automation.message.tooltipAddStep') : ''"
            :disabled="disabled"
            ref="dropdown"
            class="marketing-automation-form-steps-add"
            data-icon="mdi-plus">

    <marketing-automation-form-steps-add-type v-if="notStepSelected"
                                              @selected="setType" />

    <marketing-automation-form-steps-add-send v-if="isSendStep"
                                              @selected="emitStepType"
                                              @back="goBack" />
  </dropdown>
</template>

<script>
import MarketingAutomationFormStepsAddType from "@components/modules/marketing/automation/form/steps/add/type/MarketingAutomationFormStepsAddType";
import MarketingAutomationFormStepsAddSend from "@components/modules/marketing/automation/form/steps/add/send/MarketingAutomationFormStepsAddSend";
import Dropdown from "@components/Dropdown";

export default {
  components: {
    Dropdown,
    MarketingAutomationFormStepsAddType,
    MarketingAutomationFormStepsAddSend,
  },

  props: {
    disabled: {
      type: Boolean,
    },
  },

  computed: {
    isSendStep() {
      return this.currentStep === "SEND";
    },
    isWaitStep() {
      return this.currentStep === "WAIT";
    },
    notStepSelected() {
      return !this.currentStep;
    },
  },

  data() {
    return {
      currentStep: undefined,
    };
  },

  methods: {
    goBack() {
      this.currentStep = undefined;
    },
    setType(type) {
      if (type === "SEND") {
        this.currentStep = type;
      } else {
        this.$refs.dropdown.close();
        this.$emit("selected", {
          stepType: type,
          properties: {
            days: 0,
            hours: 0,
            minutes: 0,
            scheduledHour: undefined,
            weekendEnabled: true,
            businessHourEnabled: true,
          },
        });
      }
    },
    emitStepType(selectedType) {
      this.$refs.dropdown.close();
      this.$emit("selected", selectedType);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.marketing-automation-form-steps-add {
  margin: 15px auto;
  width: min-content;

  ::v-deep button {
    .dropdown-btn {
      width: 35px;
      height: 35px;
      padding: 0;
      display: flex;
      justify-content: center;
      border-radius: 50%;

      i {
        margin: 0;
      }
    }
  }

  ::v-deep .dropdown-menu {
    width: auto !important;
    border-color: $primary;
  }
}
</style>
